import Duck from 'extensible-duck'

const initialState = {
  showSearchModal: false,
  // TECH-20: term whose results are shown inside the search panel ('' = none)
  query: '',
}

export default new Duck({
  namespace: 'content',
  store: 'searchModal',
  types: ['TOGGLE', 'CLOSE', 'OPEN_RESULTS'],
  initialState,
  reducer: (state, action, duck) => {
    switch (action.type) {
      case duck.types.TOGGLE:
        return { showSearchModal: !state.showSearchModal, query: '' }
      case duck.types.CLOSE:
        return { showSearchModal: false, query: '' }
      case duck.types.OPEN_RESULTS:
        return { showSearchModal: true, query: action.query }
      default:
        return state
    }
  },
  creators: (duck) => ({
    toggleSearchModal: (showSearchModal) => ({
      type: duck.types.TOGGLE,
      showSearchModal,
    }),
    closeSearchModal: () => ({ type: duck.types.CLOSE }),
    openSearchResults: (query) => ({ type: duck.types.OPEN_RESULTS, query }),
  }),
})
